/**
 * @file html-track-element.js
 */

'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _utilsBrowserJs = require('../utils/browser.js');

var browser = _interopRequireWildcard(_utilsBrowserJs);

var _globalDocument = require('global/document');

var _globalDocument2 = _interopRequireDefault(_globalDocument);

var _eventTarget = require('../event-target');

var _eventTarget2 = _interopRequireDefault(_eventTarget);

var _tracksTextTrack = require('../tracks/text-track');

var _tracksTextTrack2 = _interopRequireDefault(_tracksTextTrack);

var NONE = 0;
var LOADING = 1;
var LOADED = 2;
var ERROR = 3;

/**
 * https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement
 *
 * interface HTMLTrackElement : HTMLElement {
 *   attribute DOMString kind;
 *   attribute DOMString src;
 *   attribute DOMString srclang;
 *   attribute DOMString label;
 *   attribute boolean default;
 *
 *   const unsigned short NONE = 0;
 *   const unsigned short LOADING = 1;
 *   const unsigned short LOADED = 2;
 *   const unsigned short ERROR = 3;
 *   readonly attribute unsigned short readyState;
 *
 *   readonly attribute TextTrack track;
 * };
 *
 * @param {Object} options TextTrack configuration
 * @class HTMLTrackElement
 */

var HTMLTrackElement = (function (_EventTarget) {
  _inherits(HTMLTrackElement, _EventTarget);

  function HTMLTrackElement() {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, HTMLTrackElement);

    _EventTarget.call(this);

    var readyState = undefined,
        trackElement = this;

    if (browser.IS_IE8) {
      trackElement = _globalDocument2['default'].createElement('custom');

      for (var prop in HTMLTrackElement.prototype) {
        if (prop !== 'constructor') {
          trackElement[prop] = HTMLTrackElement.prototype[prop];
        }
      }
    }

    var track = new _tracksTextTrack2['default'](options);

    trackElement.kind = track.kind;
    trackElement.src = track.src;
    trackElement.srclang = track.language;
    trackElement.label = track.label;
    trackElement['default'] = track['default'];

    Object.defineProperty(trackElement, 'readyState', {
      get: function get() {
        return readyState;
      }
    });

    Object.defineProperty(trackElement, 'track', {
      get: function get() {
        return track;
      }
    });

    readyState = NONE;

    track.addEventListener('loadeddata', function () {
      readyState = LOADED;

      trackElement.trigger({
        type: 'load',
        target: trackElement
      });
    });

    if (browser.IS_IE8) {
      return trackElement;
    }
  }

  return HTMLTrackElement;
})(_eventTarget2['default']);

HTMLTrackElement.prototype.allowedEvents_ = {
  load: 'load'
};

HTMLTrackElement.NONE = NONE;
HTMLTrackElement.LOADING = LOADING;
HTMLTrackElement.LOADED = LOADED;
HTMLTrackElement.ERROR = ERROR;

exports['default'] = HTMLTrackElement;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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